import React from "react";

export function Tabs({items=[],value,defaultValue,onChange,variant="underline",style,...rest}){
  const isControlled=value!==undefined;
  const [inner,setInner]=React.useState(defaultValue??(items[0]&&(items[0].value||items[0])));
  const active=isControlled?value:inner;
  const pick=v=>{if(!isControlled)setInner(v);onChange&&onChange(v)};
  const norm=items.map(i=>typeof i==="string"?{value:i,label:i}:i);
  const seg=variant==="segmented";
  return (
    <div role="tablist" style={{display:"flex",gap:seg?"2px":"24px",
      borderBottom:seg?"none":"1px solid var(--line-default)",
      background:seg?"var(--surface-inset)":"transparent",
      padding:seg?"3px":0,borderRadius:seg?"var(--radius-control)":0,
      ...style}} {...rest}>
      {norm.map(t=>{
        const on=t.value===active;
        return (
          <button key={t.value} role="tab" aria-selected={on} onClick={()=>pick(t.value)}
            style={{all:"unset",cursor:"pointer",fontFamily:"var(--font-display)",fontSize:"var(--text-sm)",
              fontWeight:"var(--weight-semibold)",letterSpacing:"var(--tracking-wide)",
              padding:seg?"6px 14px":"0 0 12px",borderRadius:seg?"var(--radius-1)":0,
              color:on?(seg?"var(--fg-1)":"var(--fg-1)"):"var(--fg-3)",
              background:seg&&on?"var(--surface-card)":"transparent",
              boxShadow:seg&&on?"var(--shadow-raise)":"none",
              borderBottom:seg?"none":"2px solid "+(on?"var(--cyan-500)":"transparent"),
              marginBottom:seg?0:"-1px",transition:"var(--transition-control)",display:"inline-flex",alignItems:"center",gap:"8px"}}>
            {t.icon}{t.label}
            {t.count!==undefined&&<span style={{fontFamily:"var(--font-mono)",fontSize:"var(--text-3xs)",color:"var(--fg-3)"}}>{t.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
